:host{max-width:450px}@media(max-width:768px){:host.width-tablet-full{max-width:unset}}.internal-comment span{top:17px;cursor:pointer}
/*# sourceMappingURL=comment-box.component-THYAZAUC.css.map */
